<script>
import { projectState } from "@app/store/projectStore.svelte.js";
import { eventGroupState } from "@app/store/eventGroupStore.svelte.js";
import { agentEditLock } from "@app/lib/assistant/agent/agentEditLock.svelte.js";
import { stopAssistantMessage } from "@app/store/assistantStore.svelte.js";
import * as m from "@app/paraglide/messages.js";

let group = $derived(eventGroupState[projectState.selected]);
let visible = $derived(Boolean(group?.id) && agentEditLock.groupIds.includes(group.id));
</script>

{#if visible}
    <div class="agent-edit-banner alert alert-info d-flex align-items-center gap-2 py-1 px-2 mb-0 small shadow-sm" role="status">
        <span class="spinner-grow spinner-grow-sm" aria-hidden="true"></span>
        <span>{m.assistant_agent_editing_banner({ group: group.name })}</span>
        <button type="button" class="btn btn-sm btn-outline-danger py-0" onclick={stopAssistantMessage}>
            <i class="bi bi-stop-fill me-1"></i>{m.assistant_stop()}
        </button>
    </div>
{/if}

<style>
    .agent-edit-banner {
        position: absolute;
        top: 0.5rem;
        left: 50%;
        transform: translateX(-50%);
        z-index: 1040;
        max-width: calc(100% - 1rem);
    }
</style>
